var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipseRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 529,
    viewBox: "0 0 213 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 261.648,
    cy: 258.228,
    r: 148.028,
    transform: "rotate(138.21 261.648 258.228)",
    stroke: "#168004",
    strokeWidth: 0.551994
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.37,
    cy: 270.223,
    r: 148.028,
    transform: "rotate(138.21 272.37 270.223)",
    stroke: "#168004",
    strokeWidth: 0.551994
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.738 367.681L154.687 362.587L150.255 360.073L155.35 360.022L157.864 355.59L157.915 360.685L162.347 363.199L157.252 363.25L154.738 367.681Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseRight);
export default __webpack_public_path__ + "static/media/ellipse-right.5eb53be47a25bc75ca982ab7994984e7.svg";
export { ForwardRef as ReactComponent };